import { Injectable, EventEmitter } from '@angular/core'
import PouchDB from 'pouchdb';

@Injectable({
    providedIn: 'root'
})
// @Injectable()
export class CouchPerxipo {

    private isInstantiated: boolean;
    private database: any;
    private listener: EventEmitter<any> = new EventEmitter();

    constructor() {
        if (!this.isInstantiated) {
            this.CrearPouchSincronizacion()
        }
    }

    public CrearPouchSincronizacion() {

        sIdkatios = this.GetIdKatiosLVL1FromSession();
        this.database = new PouchDB("perxtipo_" + sIdkatios, { auto_compaction: true });
        var sIdkatios: string;

        this.sync(this.GetServer() + "perxtipo_" + sIdkatios.toLowerCase());
        this.isInstantiated = true;
        console.log("********************************** INSTANCE perxtipo *****************************************")

    }

    public GetServer(): string {
        //var json = require('../../../assets/Config/config.json');
        var json = require('G:/Desarrollo/BD/WE8/config.json');
        return json.CouchDBM3;
    }

    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    public GetIdKatiosLVL1FromSession() {
        var sSessionLVL1M3 = sessionStorage.getItem("SessionLVL1M3");
        var oSessionLVL1M3;
        if (sSessionLVL1M3 !== undefined && sSessionLVL1M3 != null) {
            oSessionLVL1M3 = JSON.parse(sSessionLVL1M3);
            if (oSessionLVL1M3.UsuarioSistema.IDKATIOS !== undefined && oSessionLVL1M3.UsuarioSistema.IDKATIOS != null) {
                return oSessionLVL1M3.UsuarioSistema.IDKATIOS;
            }
        }
        return null;
    }

    public sync(remote: string) {
        let remoteDatabase = new PouchDB(remote, { auto_compaction: true });

        this.database.replicate.from(remoteDatabase, {
            live: false,
            retry: false
        }).on('complete', change => {
            console.log("********************************** COMPLETO CAMBIO perxtipo *****************************************")
        }).on('change', change => {
            this.listener.emit(change);
            console.log("********************************** CHANGE CAMBIO perxtipo *****************************************")
        }).on('error', function (err) {
            console.log("Error")
            // boo, something went wrong!
        });
    }

    public get(id: string) {
        return this.database.get(id);
    }

    public fetch() {
        return this.database.allDocs({ include_docs: true });
    }

    public getEncabezado() {
        return this.database.allDocs({ include_docs: false });
    }

    public getChangeListener() {
        return this.listener;
    }



    public async Destroy() {
        var respuesta;
        respuesta = await this.database.destroy()
        return respuesta
    }
}